export type BreadcrumbType = "nav" | "tap" | "error";
export type Breadcrumb = { type: BreadcrumbType; label: string; at: number };

export class BreadcrumbBuffer {
  private readonly cap: number;
  private entries: Breadcrumb[] = [];

  constructor(cap = 15) {
    this.cap = Math.max(1, cap);
  }

  push(entry: Breadcrumb): void {
    this.entries.push(entry);
    if (this.entries.length > this.cap) {
      this.entries = this.entries.slice(-this.cap);
    }
  }

  list(): Breadcrumb[] {
    return [...this.entries];
  }

  clear(): void {
    this.entries = [];
  }
}

export function serializeBreadcrumbs(
  entries: Breadcrumb[],
  maxBytes = 4096,
): Breadcrumb[] {
  const trimmed = entries.map((entry) => ({
    ...entry,
    label: entry.label.slice(0, 200),
  }));
  let out = [...trimmed];
  while (out.length > 0 && JSON.stringify(out).length > maxBytes) {
    out = out.slice(1);
  }
  return out;
}
